<template>
  <div class="admin-page">
    <AdminGate v-if="blocked" mode="blocked" :role-label="currentRoleLabel" />
    <AdminGate
      v-else-if="!isAdmin"
      mode="login"
      v-model="adminPassword"
      :error="loginError"
      @login="submitLogin"
    />

    <template v-else>
      <header class="admin-top">
        <div class="admin-top-inner">
          <router-link to="/" class="brand">
            <img class="mark" src="/logo.png" alt="" width="32" height="32" draggable="false" />
            <span>
              <strong>算力百科</strong>
              <small>管理后台</small>
            </span>
          </router-link>
          <div class="top-meta">
            <span class="role-pill">管理员</span>
            <button type="button" class="btn ghost sm" @click="logout">退出</button>
          </div>
        </div>
      </header>

      <div class="admin-body">
        <aside class="side">
          <nav class="side-nav">
            <button
              v-for="item in menus"
              :key="item.id"
              type="button"
              :class="{ on: tab === item.id }"
              @click="tab = item.id"
            >{{ item.label }}</button>
          </nav>
        </aside>

        <main class="main">
          <AdminCardCatalog v-show="tab === 'cards'" ref="catalog" @unauthorized="onUnauthorized" />
          <AdminGaps v-if="tab === 'gaps'" @edit="goEditCard" />
          <AdminBom v-else-if="tab === 'bom'" />
          <AdminAds v-else-if="tab === 'ads'" />
          <AdminUsers v-else-if="tab === 'users'" />
          <AdminInquiries v-else-if="tab === 'inquiries'" />
          <AdminForumReview v-else-if="tab === 'forum'" />
          <AdminArticles v-else-if="tab === 'articles'" />
          <AdminPasswords v-else-if="tab === 'passwords'" />
          <AdminSettings v-else-if="tab === 'settings'" />
        </main>
      </div>
    </template>
  </div>
</template>

<script>
import { loginAdmin } from '../api/accelService'
import { clearSession, sessionRole, setSession } from '../utils/session'
import AdminAds from './admin/AdminAds.vue'
import AdminBom from './admin/AdminBom.vue'
import AdminCardCatalog from './admin/AdminCardCatalog.vue'
import AdminUsers from './admin/AdminUsers.vue'
import AdminInquiries from './admin/AdminInquiries.vue'
import AdminForumReview from './admin/AdminForumReview.vue'
import AdminArticles from './admin/AdminArticles.vue'
import AdminGaps from './admin/AdminGaps.vue'
import AdminGate from './admin/AdminGate.vue'
import AdminPasswords from './admin/AdminPasswords.vue'
import AdminSettings from './admin/AdminSettings.vue'
import './admin/admin.css'

const ROLE_LABELS = {
  admin: '管理员',
  user: '注册用户',
  visitor: '访客'
}

export default {
  name: 'AccelAdmin',
  components: {
    AdminGate,
    AdminCardCatalog,
    AdminGaps,
    AdminBom,
    AdminAds,
    AdminUsers,
    AdminInquiries,
    AdminForumReview,
    AdminArticles,
    AdminPasswords,
    AdminSettings
  },
  data() {
    const role = sessionRole()
    return {
      currentRole: role,
      isAdmin: role === 'admin',
      blocked: role === 'visitor' || role === 'user',
      adminPassword: '',
      loginError: '',
      tab: 'cards',
      menus: [
        { id: 'cards', label: '参数目录' },
        { id: 'gaps', label: '索引缺口' },
        { id: 'bom', label: 'BOM 组件' },
        { id: 'ads', label: '广告管理' },
        { id: 'users', label: '用户' },
        { id: 'inquiries', label: '报价咨询' },
        { id: 'forum', label: '论坛审核' },
        { id: 'articles', label: '资讯推送' },
        { id: 'passwords', label: '访客密码' },
        { id: 'settings', label: '公众号文案' }
      ]
    }
  },
  computed: {
    currentRoleLabel() {
      return ROLE_LABELS[this.currentRole] || this.currentRole || '未知'
    }
  },
  methods: {
    async submitLogin() {
      this.loginError = ''
      try {
        const result = await loginAdmin(this.adminPassword)
        setSession(result.token, result.role)
        this.currentRole = result.role
        this.isAdmin = result.role === 'admin'
        this.blocked = false
        if (!this.isAdmin) {
          this.loginError = '该账号不是管理员'
          clearSession()
        }
      } catch (err) {
        this.loginError = err.response?.data?.error || '登录失败'
      }
    },
    logout() {
      clearSession()
      this.isAdmin = false
      this.blocked = false
      this.currentRole = ''
      this.adminPassword = ''
      this.tab = 'cards'
    },
    onUnauthorized() {
      this.isAdmin = false
      this.blocked = sessionRole() === 'visitor' || sessionRole() === 'user'
      this.currentRole = sessionRole()
      clearSession()
    },
    async goEditCard(id) {
      this.tab = 'cards'
      await this.$nextTick()
      if (this.$refs.catalog) await this.$refs.catalog.openFromGap(id)
    }
  }
}
</script>
